// extracted by mini-css-extract-plugin
module.exports = {"footer":"index_footer_1JJNG","footerInner":"index_footerInner_1MlQM","logo":"index_logo_3kNAc"};